import type { Campaign } from "../../lib/types";

/**
 * Three states, not two. A campaign that has never been published is as absent
 * from the storefront as one whose edits are sitting in draft, and until now it
 * said so only in passing.
 */
export type PublishState = "never" | "stale" | "live";

export const publishStateOf = (campaign: Campaign): PublishState => {
	if (campaign.publishedAt === null) return "never";
	return campaign.hasUnpublishedChanges ? "stale" : "live";
};
